import Macy from 'macy';
import bus from '../util/eventBus';

const grid = () => {
  const grids = document.querySelectorAll('.u-masonry');

  if (grids.length) {
    // eslint-disable-next-line no-unused-vars
    const macyInstance = Macy({
      container: '.u-masonry',
      trueOrder: false,
      waitForImages: true,
      margin: 15,
      columns: 3,
      breakAt: {
        1023: 2,
        768: 1,
      },
    });
    bus.on('feag-load-more-finish', () => macyInstance.recalculate());
  }
};

grid();
